export default {
	layout: {
		'/': 'Login',
		'/login': 'Login',
		'/reports': 'Reports',
		'/buildings': 'Buildings',
		'/sensors': 'Sensors',
		'/sensor-keys': 'AES Keys',
		'/gateways': 'Gateways',
		'/transfer-configs': 'Transfer Configurations',
		'/integration-configs': 'Integrations',
		'/operators': 'Operators',
		'/customers': 'Customers',
		'/users': 'Users',
		'/settings': 'Settings',
		'/organizations': 'Organizations',
		'/billing': 'Billing',
		'/dashboard': 'Dashboard',
		'/telegrams': 'Telegrams',
		'/devices': 'Devices',
		'/shared-transfer-configs': 'Shared Transfer Configurations',
		Menu: 'Menu',
		Settings: 'Settings',
		Logout: 'Logout',
		Administration: 'Administration',
	},
	table: {
		'No records to display': 'No records to display',
		Add: 'Add',
		Delete: 'Delete',
		Edit: 'Edit',
		Filter: 'Filter',
		'Are you sure delete this row?': 'Are you sure delete this row?',
		Cancel: 'Cancel',
		Save: 'Save',
		placeholder: 'placeholder',
		Actions: 'Actions',
		'{from}-{to} of {count}': '{from}-{to} of {count}',
		rows: 'rows',
		'Rows per page': 'Rows per page:',
		'First Page': 'First Page',
		'Previous Page': 'Previous Page',
		'Next Page': 'Next Page',
		'Last Page': 'Last Page',
		'Add or remove columns': 'Add or remove columns',
		'{0} row(s) selected': '{0} row(s) selected',
		'Show Columns': 'Show Columns',
		Export: 'Export',
		'Export as CSV': 'Export as CSV',
		Search: 'Search',
		Loading: 'Loading...',
		'Reset table settings': 'Reset table settings',
	},
	errors: {
		'Invalid e-mail': 'Invalid e-mail',
		'Invalid password': 'Invalid password',
	},
	login: {
		'E-mail Address': 'E-mail Address',
		Password: 'Password',
		"E-mail can't be blank": "E-mail can't be blank",
		"Password can't be blank": "Password can't be blank",
		'Password must have more than 6 characters':
			'Password must have more than 6 characters',
		'Log in': 'Log in',
		Admin: 'Admin',
	},
	reportErrors: {
		'Duplicate serial number': 'Duplicate serial number',
		'Identical sensors': 'Identical sensors',
		'Swapped sensors': 'Swapped sensors',
		'External number and serial number are mixed up': 'External number and serial number are mixed up',
	},
	report: {
		'Main reports': 'Main reports',
		New: 'New',
		Open: 'Open',
		'In Progress': 'In Progress',
		Submitted: 'Submitted',
		Confirmed: 'Imported',
		'Marked Wrong': 'Recycle bin',
		ID: 'ID',
		ID1: 'ID1',
		ID4: 'ID4',
		Status: 'Status',
		'Creation Date': 'Creation Date',
		'Update Date': 'Update Date',
		'Reading Date': 'Reading Date',
		'Submission Date': 'Submission Date',
		'Set Date': 'Set Date',
		'Building Address': 'Building Address',
		'Alternate Address': 'Alternate Address',
		'ZIP code': 'ZIP code',
		City: 'City',
		'Sensors Count': 'Sensors Count',
		'Meeters Count': 'Meeters Count',
		'Serials Count': 'Serials Count',
		'New Report': 'New Report',
		'Report not found': 'Report not found',
		'Report {{id}}': 'Report {{id}}',
		Operator: 'Operator',
		'Operator comment': 'Operator comment',
		'Last Seen': 'Last Seen',
		Comment: 'Comment',
		Sensors: 'Sensors',
		Serials: 'Serials',
		Statistics: 'Statistics',
		'Set date radio measurements': 'Set date radio measurements',
		'Reading date radio measurements': 'Reading date radio measurements',
		'Reading date hand measurements': 'Reading date hand measurements',
		'Sensors with telegram count': 'Sensors with telegram',
		'Radio Collected Count': 'Measurements from radio',
		'Hand Collected Count': 'Measurements by hand',
		'{{colledCount}} of {{sensorsCount}}':
			'{{colledCount}} of {{sensorsCount}}',
		'{{radioCollectedCount}} of {{serialsCount}}':
			'{{radioCollectedCount}} of {{serialsCount}}',
		Download: 'Download',
		Edit: 'Edit',
		Confirm: 'Status imported',
		'Building sensors': 'Building sensors',
		'Apartment sensors': 'Apartment sensors',
		'Go to Building': 'Go to Building',
		'Open map': 'Open map',
		Refresh: 'Refresh',
		'Refresh related Telegrams': 'Refresh related Telegrams',
		'This operation will schedule re-processing all measurements of telegrams from this report. Are you sure?':
			'This operation will schedule re-processing all measurements of telegrams from this report. Are you sure?',
		'Add sensors to report': 'Add sensors to report',
		'All sensors': 'All sensors',
		Readings: 'Readings',
		'Serial Number': 'Serial Number',
		'Radio Measurement Value': 'Radio Measurement Value',
		'Radio Measurement Date': 'Radio Measurement Date',
		'Hand Measurement Value': 'Hand Measurement Value',
		'Hand Measurement Date': 'Hand Measurement Date',
		'Sensor ID1': 'Sensor ID1',
		'Sensor Type': 'Sensor Type',
		'AES Key': 'AES Key',
		'Is active sensor': 'Is active sensor',
		'Telegram exists': 'Telegram exists',
		'Telegram decrypted': 'Telegram decrypted',
		'Show telegrams': 'Show telegrams',
		'Telegrams for': 'Telegrams for',
		'Captured at': 'Collected at',
		'Captured by': 'Collected by',
		'Gateway ID': 'Gateway ID',
		Manufacturer: 'Manufacturer',
		'Device type': 'Device type',
		'Select building': 'Select building',
		'Select operator': 'Select operator',
		'Select reading date': 'Select reading date',
		'Select set date': 'Select set date',
		'Reading date': 'Reading date',
		'Set date': 'Set date',
		Building: 'Building',
		'Automatic resolve': 'Automatic resolve',
		'No conflicts which can be resolved automatically':
			'No conflicts which can be resolved automatically',
		'Resolved conflicts for {{number}} sensors':
			'Resolved conflicts for {{number}} sensors',
		'Building ID1': 'Building ID1',
		'Sensor %': 'Sensor %',
		'Serial %': 'Serial %',
		'Only with requirement / User permission': 'Only with requirement / User permission',
		RSSI: 'RSSI',
		Location: 'Location',
		'User number': 'User number',
		'Telegrams Count': 'Telegrams Count',
		'Telegram %': 'Telegram Report %',
		'Telegrams Change (%)': 'Telegrams Change (%)',
		'Total Telegram %': 'Total Telegram %',
		'{{telegramCollectedCount}} of {{serialsCount}}':
			'{{telegramCollectedCount}} of {{serialsCount}}',
		'Last exports': 'Last exports',
		'never exported': 'never exported',
		'Send it to Operator': 'Send it to Operator',
	},
	building: {
		ID4: 'ID4',
		Street: 'Street',
		Number: 'Number',
		City: 'City',
		Zipcode: 'Zipcode',
		'Alternate Address': 'Alternate Address',
		'Sensors Count': 'Sensors Count',
		'Meeters Count': 'Meeters Count',
		'Serials Count': 'Serials Count',
		Refresh: 'Refresh',
		Delete: 'Delete',
		Pricing: 'Pricing',
		ID: 'ID',
		Year: 'Year',
		'Heat Variable': 'Heat Variable',
		'Heat Fixed': 'Heat Fixed',
		'Water Variable': 'Water Variable',
		'Water Fixed': 'Water Fixed',
		Sensors: 'Sensors',
		ID1: 'ID1',
		'External Number': 'External Number',
		'Set Date': 'Set Date',
		'Update Date': 'Update Date',
		Status: 'Status',
		Name: 'Name',
		Name2: 'Name 2',
		Factor: 'Factor',
		Type: 'Type',
		'Serial Number': 'Serial Number',
		Comment: 'Comment',
		'Installed Date': 'Installed Date',
		'Uninstalled Date': 'Uninstalled Date',
		Apartments: 'Apartments',
		Location: 'Location',
		'Area Heating': 'Area Heating',
		'Area Water': 'Area Water',
		'Could not upload the file': 'Could not upload the file',
		'File uploaded successfully': 'File uploaded successfully',
		'Upload Routeml': 'Upload Routeml',
		'Import method': 'Import method',
		'There are duplicate sensors in this file':
			'There are duplicate sensors in this file',
		'Apartment guid': 'Apartment guid',
		'Duplicate sensors guid': 'Duplicate sensors guid',
		'Marked Wrong': 'Recycle bin',
		'Main buildings': 'Buildings',
		'The building is going to be deleted':
			'The building is going to be deleted',
		Proceed: 'Proceed',
		Cancel: 'Cancel',
		"Full Export":"Full Export",
		"ACTIVATE_FULL_EXPORT_CONFIRM":"Activating this option will include all the data collected by corresponding building gateways, even for sensors not registered by the import data. Please activate only if you're sure it's expected behavior.",
	},
	sensorKey: {
		ID: 'ID',
		'Serial Number': 'Serial Number',
		'AES Key': 'AES Key',
		'Upload CSV': 'Upload CSV',
		'Upload CSV Help': 'Upload CSV Help',
		'upload-instructions':
			'The csv file must have the header as follow: serial_number;aes_key. Note that it should be semicolon separated values',
		Understood: 'Understood',
		Manufacturer: 'Manufacturer',
		'Individual keys': 'Individual keys',
		'Global keys': 'Global keys',
	},
	gateway: {
		ID: 'ID',
		ICCID: 'ICCID',
		IMEI: 'IMEI',
		'Serial Number': 'Serial Number',
		Manufacturer: 'Manufacturer',
		'Device type': 'Device type',
		Model: 'Model',
		'Last Reading': 'Last Reading',
		Online: 'Online',
		'Building Address': 'Building Address',
		Comment: 'Comment',
		'Choose a building': 'Choose a building',
		'ICCID is required': 'ICCID is required',
		'IMEI is required': 'IMEI is required',
		'Serial number is required': 'Serial number is required',
		'Manufacturer is required': 'Manufacturer is required',
		'Model is required': 'Model is required',
		'Select building': 'Select building',
		Building: 'Building',
		Save: 'Save',
		'Gateway not found': 'Gateway not found',
		'IMEI must have 15 numbers': 'IMEI must have 15 numbers',
		'ICCID must have 22 numbers': 'ICCID must have 20-22 numbers',
		'Could not save the gateway': 'Could not save the gateway',
		Organization: 'Organization',
		'Choose an organization': 'Choose an organization',
		'Organization is required': 'Organization is required',
		'Select manufacturer': 'Select manufacturer',
		'telegrams for gateway': 'telegrams for gateway',
		'Sensor serial number': 'Sensor serial number',
		'Captured at': 'Captured at',
		'Telegram decrypted': 'Telegram decrypted',
		'Show telegrams': 'Show telegrams',
		'Telegrams for gateway': 'Telegrams for gateway',
		'Year and month': 'Year and month',
		Battery: 'Battery',
		RSSI: 'RSSI',
		Operator: 'Operator',
		Status: 'Status',
		'Import Method': 'Import Method',
		'Start automatic building assignment': 'Start automatic building assignment',
		'Automatically assign building': 'Automatically assign building',
		'Sync gateways': 'Sync gateways',
		'Building ID1': 'Building ID1',
		'Last Sending': 'Last Sending',
		'Upload CSV/XLSX': 'Upload CSV/XLSX',
		'Upload CSV/XLSX Help': 'Upload CSV/XLSX Help',
		'upload-instructions':
			'The csv file must have the header as follow: serial_number;imei;manufacturer;customer_name;iccid. Note that it should be semicolon separated values',
		Understood: 'Understood',
		'Gateways in Operations': 'Gateways in Operations',
		'Gateways Backlog': 'Gateways Backlog',
		'Show whitelist settings': 'Show whitelist settings',
		'uploaded to the ftp server until gateway will download and apply it': 'uploaded to the ftp server until gateway will download and apply it',
		'empty whitelist uploaded to the ftp server and waiting until gateway will download it to reset currect whitelist': 'empty whitelist uploaded to the ftp server and waiting until gateway will download it to reset current whitelist',
		'applied to the gateway': 'applied to the gateway',
		'not created': 'not created',
		'Gateway whitelist': 'Gateway whitelist',
		'Whitelist status': 'Whitelist status',
		'Enable whitelist': 'Enable whitelist',
		'Remove whitelist': 'Remove whitelist',
		'Gateway updated successfully': 'Gateway updated successfully',
		"Gateway Status": "Gateway Status",
		"Deleted": "Deleted",
		"Exists and never Seen": "Exists and never Seen",
		"Exists and Seen": "Exists and Seen",
		"Empty": "Empty",
		"Gateway Import Method": "Gateway Import Method",
		"Imported by CSV": "Imported by CSV",
		"Discovered by data": "Discovered by data",
		"Imported by RouteML/API": "Imported by RouteML/API",
		"All Gateways": "All Gateways",
		"Gateways sending directly": "Gateways sending directly",
		"Gateways sending indirectly (over DSP)": "Gateways sending indirectly (over DSP)",
		"Backlog": "Backlog",
		"Created By": "Created By"
	},
	ftpConfig: {
		ID: 'ID',
		User: 'User',
		Password: 'Password',
		Host: 'Host',
		Port: 'Port',
		Setup: 'Setup',
		Folder: 'Folder',
	},
	integrationConfig: {
		ID: 'ID',
		User: 'User',
		Password: 'Passwort',
		'Api Key': 'Api Key',
		Host: 'Host',
		Port: 'Port',
		Type: 'Type',
	},
	operator: {
		ID: 'ID',
		'E-mail': 'E-mail',
		Password: 'Password',
		'First Name': 'First Name',
		'Last Name': 'Last Name',
		Phone: 'Phone',
	},
	user: {
		ID: 'ID',
		'E-mail': 'E-mail',
		Password: 'Password',
		'New password': 'New password',
		Role: 'Role',
		'First Name': 'First Name',
		'Last Name': 'Last Name',
		Phone: 'Phone',
		Apartment: 'Apartment',
		Building: 'Building',
		'Choose an apartment': 'Choose an apartment',
		'Choose a building': 'Choose a building',
		'Choose a role': 'Choose a role',
		Save: 'Save',
		Details: 'Details',
		'Could not save user': 'Could not save user',
		'User info saved': 'User info saved',
		'Could not add the apartment': 'Could not add the apartment',
		'Apartment added to user': 'Apartment added to user',
		'Start date': 'Start date',
		'End date': 'End date',
		'Street 1': 'Street 1',
		'Street 2': 'Street 2',
		'ZIP code': 'ZIP code',
		City: 'City',
		"Choose an organization": "Organisation auswählen",
		roles: {
			1: 'Customer',
			2: 'Operator',
			3: 'Admin Master',
			4: 'Admin User',
			10: 'Property Manager',
			20: 'Gateway Operator',
		},
	},
	sensor: {
		types: {
			RM: 'Smoke Detector',
			WWZ: 'Hot Water Meter',
			KWZ: 'Cold Water Meter',
			WMZ: 'Heating Meter',
			HKV: 'Heating Allocator',
			HVE: 'Electronic Heating Allocator',
			HVV: 'Evaporator Heating Allocator',
		},
		statuses: {
			0: 'Offline',
			1: 'Online',
			10: 'Disabled',
			20: 'Unused',
		},
	},
	settings: {
		Language: 'Language',
	},
	organization: {
		ID: 'ID',
		ID1: 'ID1',
		Building: 'Building',
		Buildings: 'Buildings',
		Users: 'Users',
		Name: 'Name',
		Street: 'Street',
		Number: 'Number',
		City: 'City',
		'ZIP code': 'ZIP code',
		Phone: 'Phone',
		'E-mail': 'E-mail',
		'Update Date': 'Update Date',
	},
	telegram: {
		'Telegram is not decrypted': 'Telegram is not decrypted',
		Header: 'Header',
		'Manufacturer-Specific Header': 'Manufacturer-Specific Header',
		Key: 'Key',
		Value: 'Value',
		Values: 'Values',
		Unit: 'Unit',
		Type: 'Type',
	},
	rssi: {
		'No signal': 'No signal',
		'Very weak': 'Very weak',
		Weak: 'Weak',
		Average: 'Average',
		Strong: 'Strong',
		Excellent: 'Excellent',
		'Wrong value': 'Wrong value',
	},
	dashboard: {
		'Sensor Conflicts': 'Sensor Conflicts',
		'Sensor Fails': 'Sensor Fails',
		'AMR Coverage': 'AMR Coverage',
		'Telegram Search': 'Telegram Search',
		'Sensor serial number': 'Sensor serial number',
		'Invalid Serials': 'Invalid Serials',
		'Missing AES Keys': 'Missing AES Keys',
		'Device Counters': 'Device Counters',
		'AMR Report count': 'AMR Report count',
		'AMR Report Min coverage': 'AMR Report Min coverage',
		'AMR Report Max coverage': 'AMR Report Max coverage',
		'Status': 'Status',
		'Gateways (growth rate in last 6 months)': 'Gateways (growth rate in last 6 months)',
		'Wireless Devices (growth rate in last 6 months)': 'Wireless Devices (growth rate in last 6 months)',
		'Devices Total': 'Devices Total',
		'Building (Growth Rate in last 6 months)': 'Building (Growth Rate in last 6 months)',
		'WE (Growth Rate in last 6 months)': 'WE (Growth Rate in last 6 months)',
		"Telegram Processing": "Telegram Processing",
		'Devices with Error Code': 'Devices with Error Code',
		'Number of Devices': 'Number of Devices',
		'Number of Serials': 'Number of Serials',
		'Devices not seen beyond treshold': 'Devices not seen beyond treshold',
		'Devices missing AES Key': 'Devices missing AES Key',
		'Device Reception': 'Device Reception',
		'Number of Buildings': 'Number of Buildings',
		"Device Errors": "Device Errors",
		'Double Serial Numbers': 'Double Serial Numbers',
		'Double Serial Numbers Errors': 'Double Serial Numbers Errors',
		'Buildings with Coverage below 90%': 'Buildings with Coverage below 90%',
		'No Telegram Received longer than 18M - Dispo': 'No Telegram Received longer than 18M - Dispo',
		'No Telegram Received': 'No Telegram Received',
		'No Telegram Received longer than T2 - no UVI Possible': 'No Telegram Received longer than {{T2}} - no UVI Possible',
		'No Telegram Received longer than T1 - UVI Replacement Value': 'No Telegram Received longer than {{T1}} - UVI Replacement Value',
		'No Telegram Received longer - No UVI in Building': 'No Telegram Received longer - No UVI in Building',
		'Telegram Decryption Problem': 'Telegram Decryption Problem',
		'Measurement for Billing End Period missing': 'Measurement for Billing End Period missing',
		'Declining values measured - Dispo': 'Declining values measured - Dispo',
		'Duplicate serial number entered - Dispo': 'Duplicate serial number entered - Dispo',
		'Device error - Dispo': 'Device error - Dispo',
		'No telegram received - input error device master': 'No telegram received - input error device master',
		'Telegram could not be processed - Please contact support': 'Telegram could not be processed - Please contact support',
		'noDataToDownload': 'No data to download',
		'No Error': 'No Error',
		'Gateway is not sending data': 'Gateway is not sending data',
		'Gateway Error': 'Gateway Error',
		'Gateway battery / hardware problem': 'Gateway battery / hardware problem',
		'Never received a telegram': 'Never received a telegram',
	},
	passwordRecovery: {
		'Back to login': 'Back to login',
		'Password recovery': 'Password recovery',
		CHANGE_PASSWORD_FORM_INFO: 'Please enter new password, it should have at least {length} characters.',
		'New password': 'New password',
		'Repeat new password': 'Repeat new password',
		'Change password': 'Change password',
		"Passwords doesn't match": "Passwords don't match",
		'Password successfully changed': 'Password successfully changed',
		PASSWORD_CHANGE_ERROR: 'An error occured during password changing',
		EMAIL_FORM_INFO: 'Please enter your email and press the button below, after that recovery code will be send to your email.',
		'Send recovery code': 'Send recovery code',
		RECOVERY_CODE_FORM_INFO: 'Please enter the code that was sent to',
		'This code is no longer valid': 'This code is no longer valid',
		'Recovery code': 'Recovery code',
		"Recovery code can't be blank": "Recovery code can't be blank",
		'Submit code': 'Submit code',
	},
	"billing": {
		"Include in billing report": "Include in billing report",
		"Exclude from billing report": "Exclude from billing report",
		"Month": "Month",
		"Total": "Total",
		"Date": "Date",
		"Download CSV": "Download CSV",
		"Set date": "Set date",
		"Error": "Error",
		"Invoices": "Invoices",
		"Rate Values": "Rate Values",
		"Rate": "Rate",
		"Description": "Description",
		"Price per item": "Price per item",
		"Default price per item": "Default price per item",
		"Fixed Price": "Fixed Price",
		"Active Gates": "Active Gates",
		"Active Sensors Radio Measured": "Active Sensors Radio Measured",
		"Active Sensors Manual Measured": "Active Sensors Manual Measured",
		"Active SIM Cards": "Active SIM Cards",
		'Active Gateways MQ': 'Active Gateways MQ',
	}
};
